import { oc } from '@orpc/contract'
import { z } from 'zod'

export const taskSchema = z.object({
  id: z.string().min(1),
  projectId: z.string().min(1),
  title: z.string(),
  // NOTE: Plain-text description kept for backward compat. Prefer descriptionJson when available.
  description: z.string().nullable(),
  descriptionJson: z.unknown().nullable().default(null),
  status: z.string(),
  columnName: z.string(),
  position: z.number(),
  priority: z.number().int().default(0),
  tags: z.array(z.string()).default([]),
  // NOTE: Deprecated — kept for backward compatibility. Use assigneeIds instead.
  assigneeId: z.string().nullable().default(null),
  assigneeIds: z.array(z.string()).default([]),
  dueDate: z.string().nullable().default(null),
  commentCount: z.number().int().default(0),
  attachmentCount: z.number().int().default(0),
  subtaskTotal: z.number().int().default(0),
  subtaskCompleted: z.number().int().default(0),
  createdAt: z.string(),
  updatedAt: z.string(),
})

export const tasksListContract = oc
  .input(
    z.object({
      projectId: z.string().min(1),
    })
  )
  .output(
    z.object({
      items: z.array(taskSchema),
    })
  )

export const tasksCreateContract = oc
  .input(
    z.object({
      projectId: z.string().min(1),
      title: z.string().min(1),
      description: z.string().optional(),
      descriptionJson: z.unknown().nullable().optional(),
      columnName: z.string().optional(),
      priority: z.number().int().min(-1).max(1).optional(),
      tags: z.array(z.string()).optional(),
      // NOTE: Deprecated — kept for backward compatibility. Use assigneeIds instead.
      assigneeId: z.string().nullable().optional(),
      assigneeIds: z.array(z.string()).optional(),
      dueDate: z.string().nullable().optional(),
    })
  )
  .output(taskSchema)

export const tasksUpdateContract = oc
  .input(
    z.object({
      projectId: z.string().min(1),
      taskId: z.string().min(1),
      title: z.string().min(1).optional(),
      description: z.string().nullable().optional(),
      descriptionJson: z.unknown().nullable().optional(),
      status: z.string().optional(),
      columnName: z.string().optional(),
      priority: z.number().int().min(-1).max(1).optional(),
      tags: z.array(z.string()).optional(),
      // NOTE: Deprecated — kept for backward compatibility. Use assigneeIds instead.
      assigneeId: z.string().nullable().optional(),
      assigneeIds: z.array(z.string()).optional(),
      dueDate: z.string().nullable().optional(),
    })
  )
  .output(taskSchema)

export const tasksReorderContract = oc
  .input(
    z.object({
      projectId: z.string().min(1),
      taskId: z.string().min(1),
      columnName: z.string(),
      position: z.number(),
    })
  )
  .output(taskSchema)

export const tasksMyCountContract = oc
  .input(
    z.object({
      projectId: z.string().min(1),
    })
  )
  .output(
    z.object({
      count: z.number().int(),
    })
  )

export const tasksDeleteContract = oc
  .input(
    z.object({
      projectId: z.string().min(1),
      taskId: z.string().min(1),
    })
  )
  .output(z.object({ ok: z.literal(true) }))

export const tasksListChatThreadLinksContract = oc
  .input(
    z.object({
      projectId: z.string().min(1),
      taskId: z.string().min(1),
    })
  )
  .output(
    z.object({
      threads: z.array(
        z.object({
          threadId: z.string(),
          title: z.string().nullable(),
          createdAt: z.string(),
        })
      ),
    })
  )
